import React, { useEffect } from 'react';
import Screen from '../../components/layout/Screen';
import { ICONS } from '../../common/icons/icons';
import { useScan } from '../../common/context/ScanProvider';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

const ChoosePhotoScreen = () => {
  const { saveOriginalImage, clearOriginalImage } = useScan();
  const navigate = useNavigate();

  useEffect(() => {
    clearOriginalImage();
  }, []);

  const handlePhotoSelect = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        saveOriginalImage(reader.result);
        navigate('/scan');
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Screen
      screenContainerClassName='bg-background'
      screenOptions={{
        header: {
          title: 'Let`s scan',
          backBtnLabel: 'Back',
          backBtnUrl: '/home',
          titleClassName: 'text-white',
        },
        tabNavigator: {
          hide: true,
        },
      }}
    >
      <section className='grid grid-rows-10 gap-3 h-full'>
        <article className='row-span-2 w-full overflow-hidden'>
          <div className='w-[1000px] h-full'>
            <img src='assets/images/books_1.png' className='h-full w-auto relative -left-8' alt='' />
          </div>
        </article>
        <article className='row-span-2 w-full overflow-hidden'>
          <div className='w-[1000px] h-full'>
            <img src='assets/images/books_2.png' className='h-full w-auto relative -left-20' alt='' />
          </div>
        </article>
        <article className='row-span-2 w-full overflow-hidden'>
          <div className='w-[1000px] h-full'>
            <img src='assets/images/books_3.png' className='h-full w-auto relative -left-3' alt='' />
          </div>
        </article>
        <article className='row-span-4 px-4 grid grid-rows-10'>
          <section className='row-span-6 flex flex-col items-center justify-center '>
            <h2 className='text-white text-xl font-medium w-2/3 text-center mb-1'>Gateway to Unlimited Books Magic!</h2>
            <p className='text-white/40 text-center'>
              Seamless books quotes on-the-go: your smart helper in your pocket!
            </p>
          </section>
          <section className='row-span-4 flex flex-col'>
            <Button asChild variant='ghost' className='w-full'>
              <label htmlFor='dropzone-file'>
                Choose from photos
                <input
                  id='dropzone-file'
                  onChange={handlePhotoSelect}
                  type='file'
                  accept='image/*'
                  className='hidden'
                />
              </label>
            </Button>

            <Button asChild className='mt-3 w-full'>
              <label htmlFor='dropzone-file-photo'>
                Take a photo
                <input
                  id='dropzone-file-photo'
                  onChange={handlePhotoSelect}
                  type='file'
                  accept='image/*'
                  capture='environment'
                  className='hidden'
                />
              </label>
            </Button>
          </section>
        </article>
      </section>
    </Screen>
  );
};

export default ChoosePhotoScreen;
